import { render } from "./EmptySearchResults.vue?vue&type=template&id=b2c35ff0&scoped=true"
import script from "./EmptySearchResults.vue?vue&type=script&lang=js"
export * from "./EmptySearchResults.vue?vue&type=script&lang=js"

import "./EmptySearchResults.vue?vue&type=style&index=0&id=b2c35ff0&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c35ff0"]])

export default __exports__